class Select {

  constructor(elem) {
    this.select = elem;
    this.selectDay = this.select.find('[data-select-days]');
    this.selectMonth = this.select.find('[data-select-mounth]');
    this.selectYear = this.select.find('[data-select-year]');
	}

  initialize() {
    const that = this;

    this.select.on('change', (e) => {
      let value = e.target.value;
      let submit = this.select.data('submit');
      this.select.attr('value', value);
      if (submit) {
        const action = this.select.parent().attr('action');
        const parts = action.split('?');
        const param = this.select.attr('name');
        if (parts.length > 1) {
          window.location.href = action + '&' + param + '=' + value;
        } else {
          window.location.href = action + '?' + param + '=' + value;
        }
        return false;
      }
    })

    let isIosPhone = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)

    let isMac = (navigator.userAgent.includes("Mac"))

    if (isIosPhone) {
      this.select.on('focus blur click', (e) => {
        e.stopPropagation();
        if (e.type === 'blur') {
          that.select.removeClass('focus');
        } else if (e.type === 'focus') {
          that.select.addClass('focus');
        }
      });
    } else if (isMac) {
      this.select.on('change mousedown click', (e) => {
        e.stopPropagation();
        if (e.type === 'change') {
          that.select.removeClass('focus');
        } else if (e.type === 'mousedown') {
          that.select.addClass('focus');
        }
      });
    } else {
      this.select.on('click', (e) => {
        e.stopPropagation();
        let isOpen = that.select.hasClass('focus');
        if (isOpen) {
          that.select.removeClass('focus');
        } else {
          that.select.toggleClass('focus');
        }
      });
    }

    $('body').on('click', function() {
      that.select.removeClass('focus');
    });
	}

  initializeRelated() {
    this.selectMonth.on('change', (e) => {
      let month = e.target.value;
      let year = this.selectYear.find('option:selected').val();
      let days;

      if (year > 0) {
        days = parseInt(this.daysInMonth(year, month));
      } else {
        year = new Date().getFullYear();
        days = parseInt(this.daysInMonth(year, month));
      }

      this.setDays(days)

      this.checkSelect()
    })

    this.selectYear.on('change', (e) => {
      let year = e.target.value;
      let month = this.selectMonth.find('option:selected').val();
      let days;

      if (month > 0) {
        days = this.daysInMonth(year, month)

        this.setDays(days)
      }

      this.checkSelect()
    })

    this.selectDay.on('change', (e) => {
      this.checkSelect()
    })
  }

  daysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  setDays(days) {
    let options = this.selectDay.find('option');
    let length = options.length - 1;

    if (days > length) {
      for (let j = length; j < days; j++) {
        this.selectDay.append(`<option class="pl-2" value="${j + 1}">${j + 1}</option>`)
      }
    } else {
      let i = length - days;

      for (let j = 0; j < i; j++) {
        options.eq(length - j).remove();
      }
    }
  }

  checkSelect() {
    let dateNow = new Date();
    let yearNow = dateNow.getFullYear();
    let monthNow = dateNow.getMonth();
    let dayNow = dateNow.getDate();

    let year = this.selectYear.val();
    let month = this.selectMonth.val();
    let day = this.selectDay.val();

    let res = true;

    if (year != 'default' && month != 'default' && day != 'default') {
      if (year == yearNow && month - 1 == monthNow && day >= dayNow) {
        res =  false;
      } else if (year == yearNow && month - 1 > monthNow) {
        res =  false;
      }
    }

    if (day != 'default') {
      if (!res) {
        this.selectDay.addClass('invalid')

        if (this.selectDay.next('label').length < 1) {
          this.selectDay.after('<label id="day-error" class="invalid" for="day" style="">Выбрана некоректная дата</label>')
        } else {
          this.selectDay.next().text('Выбрана некоректная дата')
          this.selectDay.next().show()
        }
      } else {
        this.selectDay.removeClass('invalid')
        this.selectDay.next().hide()
      }
    }
  }
}

export {Select};

$(window).on('load', () => {
  let selects = [];
  let selectRelated = [];

  if ($('select').length > 0) {
		$('select').each(function(i) {
			selects[i] = new Select($(this));
			selects[i].initialize();
		});
	}

  if ($('[data-select-related]').length > 0) {
		$('[data-select-related]').each(function(i) {
			selectRelated[i] = new Select($(this));
			selectRelated[i].initializeRelated();
		});
	}
});
